import api from './api';

// Admin > Billing > OHIP Transactions.
//
// One endpoint, four views — the `view` parameter selects rows / summary / filters / runs. The first three
// share the same filter parameters, so the caller builds one params object and passes it to whichever it
// needs; a separate endpoint per view would mean the filter contract had to be kept identical in three
// places.
//
// `runs` is the odd one out: it reads Step Functions rather than OpenSearch and takes no date filters. It
// rides on this endpoint anyway — a path of its own would mean an admin API Gateway change and a lambda
// permission for a screen that belongs to the same feature and the same reader.
//
// `from_` rather than `from` for the paging offset: `from` and `to` are the DATE range, and the lambda
// would otherwise have two different meanings for the same word.
// A `vendorId` in the params sends the call to the MAIN-API door (/ohip-transactions) instead — Vendor
// Settings > OHIP Transactions. The lambda narrows it to the hotel codes that vendor reaches; runs, rerun
// and the admin views are not on that door.
const pathFor = (params) => (params && params.vendorId ? '/ohip-transactions' : '/admin/ohip-transactions');

const ohipTransactionsService = {
    rows: (params) => api.get(pathFor(params), { params: { ...params, view: 'rows' } }),
    summary: (params) => api.get(pathFor(params), { params: { ...params, view: 'summary' } }),
    filters: (params) => api.get(pathFor(params), { params: { ...(params || {}), view: 'filters' } }),
    // Admin > Billing > Extraction Runs. `limit` is capped at 60 by the lambda; `status` filters to one
    // Step Functions status (SUCCEEDED / FAILED / RUNNING / TIMED_OUT / ABORTED) or ALL.
    runs: (params) => api.get('/admin/ohip-transactions', { params: { ...params, view: 'runs' } }),
    // Start the daily ingest again. A POST because it starts work — a mutation behind a GET is one browser
    // prefetch away from a run nobody asked for. Refused with 409 while one is already in progress.
    rerun: ({ executionArn }) => api.post('/admin/ohip-transactions', { action: 'rerun', executionArn }),
};

export default ohipTransactionsService;
